import { useTranslation } from 'react-i18next';
import { FormProvider, useWatch } from 'react-hook-form';
import { ControlledCheckboxNew } from '@Components/inputs/ControlledInputs';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { OnboardingFormFields } from '@Types/types';
import { useAddUBOLogic } from './hooks/useAddUBOLogic';
import { useUBOCountries } from './hooks/useUBOCountries';
import { UBOBasicInfoSection } from './components/UBOBasicInfoSection';
import { UBOIdentityUS } from './components/UBOIdentityUS';
import { UBOIdentityNonUS } from './components/UBOIdentityNonUS';
import { UBOHomeAddress } from './components/UBOHomeAddress';

export const AddUBO = () => {
  const { t } = useTranslation();
  const { formMethods, handleSubmit, isLoading, onBackClick, countries } = useAddUBOLogic();

  const { countriesList, nonUsCountriesList, phoneCountryCodes } = useUBOCountries({
    countries,
  });
  const isUsResident = useWatch({ control: formMethods.control, name: 'isUsResident' });

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        handleSubmit={formMethods.handleSubmit(handleSubmit)}
        heading={t('pages.addOwner.title')}
        formMethods={formMethods}
        customBackHandling={onBackClick}
        maxWidth={920}>
        <div className='flex flex-col w-full gap-4 sm:gap-6 pb-[24px]'>
          <UBOBasicInfoSection />
          {isUsResident ? (
            <UBOIdentityUS />
          ) : (
            <UBOIdentityNonUS
              nonUsCountriesList={nonUsCountriesList}
              phoneCountryCodes={phoneCountryCodes}
              countries={countries}
            />
          )}
          <UBOHomeAddress
            isUsResident={isUsResident}
            countriesList={countriesList}
            countries={countries}
          />
          {!isUsResident && (
            <div className='flex flex-col gap-[8px] items-baseline'>
              <ControlledCheckboxNew
                control={formMethods.control}
                name={OnboardingFormFields.IDENTITY_NON_US_AGREEMENT_A}
                id={OnboardingFormFields.IDENTITY_NON_US_AGREEMENT_A}
                props={{
                  label: t('pages.nonUsIdentity.agreementAOwner'),
                  labelTextColor: 'text-text-main-tertiary',
                }}
              />
            </div>
          )}
        </div>
      </StepPageWrapper>
    </FormProvider>
  );
};
